import { render, staticRenderFns } from "./positions.vue?vue&type=template&id=66005f58&scoped=true"
import script from "./positions.vue?vue&type=script&lang=js"
export * from "./positions.vue?vue&type=script&lang=js"
import style0 from "./positions.vue?vue&type=style&index=0&id=66005f58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66005f58",
  null
  
)

export default component.exports